import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  @Input() defaultHref: string;
  @Input() defaultHrefIcon: string;
  @Input() buttonEndIconName: string;
  @Input() buttonEndIconSrc: string;
  @Input() buttonEndIconColor: string;
  @Input() buttonStartIconName: string;
  @Input() buttonStartIconSrc: string;
  @Input() buttonStartIconColor: string;
  @Input() centeredTitle: boolean;
  @Input() headerColor = '#ffffff';
  @Input() buttonsStartContent: boolean;
  @Input() buttonsEndContent: boolean;
  @Input() titleStyle: Record<string, string>;
  @Input() keepMobileHeader: boolean;
  @Output() clickEndBtn = new EventEmitter();
  @Output() clickStartBtn = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  clickEndBtnHandler() {
    this.clickEndBtn.emit();
  }
  clickStartBtnHandler() {
    this.clickStartBtn.emit();
  }
}
